import React from "react";
import {
  Box,
  Center,
  Text,
  Flex,
  Button,
  Image,
  VStack,
} from "@chakra-ui/react";
import { ActiveLinkProvider } from "./ActiveLinkContext";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import lashes from "../images/lashestint.jpg";
import spa from "../images/spa.jpg";

// Sample images for each section
import nails from "../images/nails.jpg";
import kidsImage from "../images/kids.jpg";
import lashesImage from "../images/lashes.jpg";
import waxingImage from "../images/waxing.jpg";
import salon from "../images/salon.jpg";

const services = [
  {
    title: "Lash Extensions",
    image: lashesImage,
    pricing: [
      {
        name: "Classic Sets",
        price: "$85+",
        sub: [
          { name: "Charlotte", price: "$85" },
          { name: "Cleopatra", price: "$99" },
          { name: "Victoria", price: "$90" },
        ],
      },
      {
        name: "Classic Fills",
        price: "$40+",
        sub: [
          { name: "1 week", price: "$40 (90%)" },
          { name: "2 week", price: "$55 (75%)" },
          { name: "3 week", price: "$75 (50%)" },
        ],
      },
      {
        name: "Hybrid Sets",
        price: "$160+",
        sub: [
          { name: "Victoria", price: "$160" },
          { name: "Hybrid Sets - Cleopatra", price: "$180" },
        ],
      },
      {
        name: "Hybrid Fills",
        price: "$55+",
        sub: [
          { name: "1 week", price: "$55 (90%)" },
          { name: "2 week", price: "$65 (75%)" },
          { name: "3 week", price: "$75 (50%)" },
        ],
      },
      {
        name: "Volume Sets",
        price: "$175+",
        sub: [
          { name: "Victoria", price: "$175" },
          { name: "Cleopatra", price: "$195" },
        ],
      },
      {
        name: "Volume Fills",
        price: "$65+",
        sub: [
          { name: "1 week", price: "$65 (90%)" },
          { name: "2 week", price: "$75 (75%)" },
          { name: "3 week", price: "$85 (50%)" },
        ],
      },
    ],
  },
  {
    title: "Lifts & Tints",
    image: lashes,
    pricing: [
      { name: "Lash Lift", price: "$60" },
      { name: "Lash Tint", price: "$45" },
      { name: "Brow Tint", price: "$35" },
    ],
  },
  {
    title: "Waxing",
    image: waxingImage,
    pricing: [
      {
        name: "Face",
        price: "$15+",
        sub: [
          { name: "Chin", price: "$15+" },
          { name: "Eyebrows", price: "$20+" },
          { name: "Lips", price: "$15+" },
          { name: "Sideburns", price: "$15+" },
          { name: "Full face", price: "$40+" },
        ],
      },
      {
        name: "Arms",
        price: "$40+",
        sub: [
          { name: "Half", price: "$40+" },
          { name: "Full", price: "$45+" },
        ],
      },
      { name: "Underarms", price: "$25+" },
      {
        name: "Legs",
        price: "$42+",
        sub: [
          { name: "Lower", price: "$42+" },
          { name: "Upper", price: "$46+" },
          { name: "Full", price: "$75+" },
        ],
      },
      {
        name: "Bikini",
        price: "$45+",
        sub: [
          { name: "Line", price: "$35+" },
          { name: "Brazilian", price: "$75+" },
        ],
      },

      { name: "Back", price: "$65+" },

      { name: "Stomach", price: "$35+" },
      { name: "Chest", price: "$40+" },
    ],
  },
  {
    title: "Quick Services",
    image: nails,
    pricing: [
      { name: "Hand/toes polish change with lacquer polish", price: "$20" },
      { name: "Polish change with Gel", price: "$30" },
      { name: "Cut and shape included" },
      { name: "*French add $10" },
      { name: "Nail soak off", price: "$15" },
      { name: "Gel removal", price: "$10" },
      { name: "UV Gel soak off", price: "$20" },
    ],
  },
  {
    title: "Spa Manicure & Pedicure",
    image: spa,
    pricing: [
      {
        name: "Acrylic Set",
        price: "$50+",
        sub: [{ name: "Acrylic Fill", price: "$40" }],
      },
      {
        name: "Gel Builder Set",
        price: "$60+",
        sub: [{ name: "Gel Builder Fill", price: "$45" }],
      },
      {
        name: "Gel-X Tip Extensions",
        price: "$80+",
        sub: [{ name: "Gel-X Fill", price: "$65" }],
      },
      {
        name: "Gel Dipping Powder - ",
        price: "$60+",
        sub: [
          { name: "Natural Nail", price: "$60" },
          { name: "Full-set with Tips", price: "$70" },
          { name: "French/ombre add", price: "$10" },
        ],
      },
      { name: "Deluxe pedicure", price: "$80" },
      { name: "Bubble Spa Pedicure", price: "$68" },
      { name: "Basic Pedi Detox", price: "$50" },
      { name: "Express Pedicure", price: "$40" },
      { name: "*$15 upcharge for gel on all pedicures" },
    ],
  },

  {
    title: "Kids Zone",
    image: kidsImage,
    pricing: [
      { name: "*For our guests 10 years and younger" },
      { name: "Princess feet", price: "$30" },
      { name: "Princess mani", price: "$20" },
    ],
  },
  {
    title: "Services Request",
    image:
      "https://i.pinimg.com/564x/bf/3e/9d/bf3e9de86e953a73bdbbabd6c6c104b8.jpg",
    pricing: [
      { name: "Nail Art", price: "$25 and up" },
      { name: "2 nail designs", price: "$10+" },
      { name: "Extra length nail", price: "$10+" },
      {
        name: "Feel free to ask our artist for any special requests, we will try our best to make it happen! ",
      },
    ],
  },
];

function Services() {
  return (
    <ActiveLinkProvider>
      <Header />
      {/* Responsive Background Image Box */}
      <Box
        height={{ base: "40vh", md: "60vh" }} // Height is smaller on mobile, larger on desktop
        position="relative"
        backgroundPosition="center"
        backgroundRepeat="no-repeat"
        backgroundSize="cover"
        backgroundImage={salon}
      ></Box>

      {/* Main Service Box with responsive padding */}
      <Box
        padding={{ base: 4, md: 8 }}
        bg={
          "linear-gradient(179.4deg, rgb(253, 240, 233) 2.2%, rgb(255, 194, 203) 96.2%)"
        }
      >
        {services.map((service, index) => (
          <Flex
            key={index}
            direction={{
              base: "column",
              md: index % 2 === 0 ? "row" : "row-reverse",
            }} // Stacks vertically on mobile, alternates on larger screens
            align="center"
            mb={{ base: 6, md: 10 }} // Adjusts margin between sections based on screen size
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            boxShadow="lg"
            bg="white"
            padding={{ base: 6, md: 10 }}
          >
            <Box flex={1} padding={4}>
              {/* Responsive Image */}
              <Image
                src={service.image}
                alt={service.title}
                borderRadius="md"
                height={{ base: "250px", md: "450px" }} // Adjusts image height for smaller screens
                width={{ base: "100%", md: "80%" }} // Full width on mobile, 80% on larger screens
                objectFit="cover"
              />
            </Box>

            <Box flex={1} padding={4}>
              <Text
                fontSize={{ base: "2xl", md: "3xl" }} // Adjusts font size for mobile
                fontWeight="bold"
                color="pink.500"
                mb={2}
                padding={"5px"}
                paddingBottom={"20px"}
                fontFamily={["Dancing Script", "cursive"]}
              >
                {service.title}
              </Text>

              <VStack spacing={2} align="start">
                {service.pricing.map((item, idx) => (
                  <Box key={idx} width="100%">
                    <Flex
                      justify="space-between"
                      align="center"
                      fontSize={{ base: "md", md: "lg" }} // Adjusts font size for pricing text
                      marginBottom={"10px"}
                    >
                      <Text
                        fontWeight={
                          !item.price || item.name.startsWith("*")
                            ? "bold"
                            : "normal"
                        }
                        marginLeft={
                          !item.price || item.name.startsWith("*")
                            ? "30px"
                            : "normal"
                        }
                      >
                        {item.name}
                      </Text>
                      {item.price && !item.name.startsWith("*") ? (
                        <Box flex="1" mx={2}>
                          <hr
                            style={{
                              border: "none",
                              borderTop: "2px dotted gray",
                              width: "100%",
                            }}
                          />
                        </Box>
                      ) : null}
                      {item.price && !item.name.startsWith("*") && (
                        <Text>{item.price}</Text>
                      )}
                    </Flex>

                    {item.sub &&
                      item.sub.map((subItem, subIdx) => (
                        <Flex
                          key={subIdx}
                          justify="space-between"
                          align="center"
                          fontSize={{ base: "md", md: "lg" }}
                          marginBottom={"10px"}
                          marginLeft="20px" // Indent for sub-options
                        >
                          <Text
                            fontWeight={
                              !subItem.price || subItem.name.startsWith("*")
                                ? "bold"
                                : "normal"
                            }
                          >
                            {subItem.name}
                          </Text>
                          {subItem.price && !subItem.name.startsWith("*") ? (
                            <Box flex="1" mx={2}>
                              <hr
                                style={{
                                  border: "none",
                                  borderTop: "2px dotted gray",
                                  width: "100%",
                                }}
                              />
                            </Box>
                          ) : null}
                          {subItem.price && !subItem.name.startsWith("*") && (
                            <Text>{subItem.price}</Text>
                          )}
                        </Flex>
                      ))}
                  </Box>
                ))}
              </VStack>
              {service.title === "Spa Manicure & Pedicure" && (
                <Link to="/spa-manicure-pedicure">
                  <Button
                    colorScheme="pink"
                    size="md"
                    mt={4}
                    alignSelf="flex-start"
                  >
                    Learn More
                  </Button>
                </Link>
              )}
            </Box>
          </Flex>
        ))}
        <Center>
          <Text
            padding={"20px"}
            fontSize={"lg"}
            mt={"10px"}
            fontFamily={"Dosis"}
            fontWeight={"600"}
            wordBreak={"break-word"}
            width={"50%"}
            mb={"20px"}
          >
            WE ARE BY APPOINTMENT ONLY. <br /> <br /> Please note that all
            appointment bookings and cancellations must be made at least 24
            hours in advance. If you are unable to attend, kindly notify us as
            soon as possible. Cancellations made less than 24 hours prior to
            your appointment will incur a $25 fee. The team at Annie's Nails and
            Lashes sincerely appreciate your cooperation.
          </Text>
        </Center>
      </Box>
      <Footer />
    </ActiveLinkProvider>
  );
}

export default Services;
